/* eslint-disable no-unused-expressions */
import React from 'react';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import {
  apiGetProductList,
  // apiUpdateProduct,
  // apiAddProduct,
  apiCreateProductTesting,
  apiUpdateParticularProduct,
  apiProductTestingDetail,
  apiGetProductDetail,
  apiUpdateProductTesting,
} from 'api';
import useOptions from 'hooks/useOptions';
import { useActions } from 'views/AddProduct/selectorData';
import { StaticDataContext } from '../StaticDataProvider';
import { getBR } from './utils';
export const CreateTestingJobContext = React.createContext({});

export const CreateTestingJobProvider = ({ productTestingId, children, companyId }) => {
  const { countryListOptions } = useOptions();
  const { getOptions, getData } = React.useContext(StaticDataContext);
  const [fetchingProductDetails, setFetchingProductDetails] = React.useState(false);
  const { addProduct } = useActions();
  // const [rawData, setRawData] = React.useState(null);
  const [requirement, setRequirement] = React.useState({});
  const [testingLab, setTestingLab] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [products, setProducts] = React.useState([]);
  const [productTestings, setProductTestings] = React.useState([]);

  const [pagination, setPagination] = React.useState({
    page: 1,
    pageSize: 20,
  });
  const [search, setSearch] = React.useState({ searchBy: 'productName', keyword: '' });
  const [order, setOrder] = React.useState({ orderBy: 'updatedAt', direction: 'desc' });
  const [filter, setFilters] = React.useState({});
  const fetchProducts = async (
    data = {
      keyword: search.keyword,
      searchBy: search.searchBy,
      criterions: {
        ...filter,
      },
      pageNo: pagination.page,
      pageSize: pagination.pageSize,
      orderBy: `${order.orderBy}:${order.direction}`,
    },
    refreshed,
    callback
  ) => {
    try {
      setLoading(true);
      isEmpty(data.criterions) && delete data.criterions;
      if (isEmpty(data.keyword)) {
        delete data.keyword;
        delete data.searchBy;
      }

      const params = {
        ...data,
        companyId,
        isActive: true, // only select the existing product as "active"
      };

      const response = await apiGetProductList(params);
      const { status } = response || {};
      if (status === 200) {
        if (refreshed) {
          setTimeout(() => {
            setProducts([...(get(response, 'data.list') || [])]);
          });
        } else {
          setProducts(products.concat(get(response, 'data.list') || []));
        }
        callback && callback();
      } else {
        throw response;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (
    nextPagination,
    nextSearch,
    nextOrder,
    nextFilters,
    action,
    refreshed = true,
    callback
  ) => {
    if (action === 'search') {
      setSearch(nextSearch);
      setPagination({ ...pagination, page: 1 });
    }
    if (action === 'order') {
      setOrder(nextOrder);
      setPagination({ ...pagination, page: 1 });
    }
    if (action === 'filter') {
      setFilters(nextFilters);
      setPagination({ ...pagination, page: 1 });
    }
    if (action === 'pagination') {
      setPagination(nextPagination);
    }
    fetchProducts(
      {
        keyword: nextSearch.keyword,
        searchBy: nextSearch.searchBy,
        criterions: {
          ...nextFilters,
        },
        pageNo: nextPagination.page,
        pageSize: nextPagination.pageSize,
        orderBy: `${nextOrder.orderBy}:${nextOrder.direction}`,
      },
      refreshed,
      callback
    );
  };

  const addProductTesting = (data) => {
    const nextProductTestings = [...productTestings];
    nextProductTestings.push(data);
    setProductTestings([...nextProductTestings]);
  };

  const updateProductTesting = async (data, index, action) => {
    const nextProductTestings = [...productTestings];
    nextProductTestings[index] = { ...data };
    if (data.id && action === 'product') {
      const params = {
        name: data.name,
        itemNo: data.itemNo,
        additionalItemNo: data.addNoTags.map(({ value }) => value).join(','),
        productCategories: data.productCategories,
        reportName: data.itemNameReport || data.name,
        reportItemNo: data.itemNoReport || data.itemNo,
        suppliers: data?.suppliers || [],
      };
      try {
        await apiUpdateParticularProduct(data.id, {
          ...params,
        });
      } catch (error) {}
    }
    setProductTestings([...nextProductTestings]);
  };

  const updateManyProductTesting = (data) => {
    setProductTestings([...data]);
  };

  const removeProductTesting = (data, index) => {
    const nextProductTestings = [...productTestings];
    nextProductTestings.splice(index, 1);
    setProductTestings([...nextProductTestings]);
  };
  const onChangeRequirement = (data) => {
    setRequirement(data);
  };
  const handleAddOrUpdateProduct = async () => {
    const paramsProductTestings = [...productTestings];
    const willCreateProduct = productTestings
      .map((product, index) => ({ product, productTestingIndex: index }))
      .filter(({ product }) => !product.id && !product.testingProductInfoId);

    if (willCreateProduct.length) {
      await willCreateProduct.reduce(async (acc, current) => {
        await acc;
        const {
          itemNameReport,
          itemNoReport,
          addNoTags = [],
          itemNo,
          name,
          productCategories,
          suppliers = [],
        } = current.product;

        const response = await new Promise((resolve, reject) => {
          addProduct(
            {
              companyId,
              itemNo,
              name,
              productCategories,
              additionalItemNo: addNoTags.map(({ value }) => value).join(', '),
              suppliers,
            },
            (response) => {
              resolve(response);
            }
          );
        });

        if (response) {
          paramsProductTestings[current.productTestingIndex] = {
            ...response.data?.data?.created,
            companyId,
            productCategories,
            addNoTags,
            itemNameReport,
            itemNoReport,
          };
        }
      }, Promise.resolve());
    }
    return paramsProductTestings;
  };
  const handleCreateOrUpdateProductTesting = async (params) => {
    const response = await (productTestingId
      ? apiUpdateProductTesting(productTestingId, params)
      : apiCreateProductTesting(params));
    const { status } = response;
    if (status === 200 || status === 201) return response.data;
    throw {
      ...response,
    };
  };
  const handleCreateOrder = async (data, callback) => {
    const updated = await handleAddOrUpdateProduct(productTestings);
    const params = getBR({ requirement, countryListOptions, updated, data });
    return handleCreateOrUpdateProductTesting(params, callback);
  };

  // Extracting Product Testing Detail.
  const extractData = async (data) => {
    //Service Level is Constant Option should get Data;
    const serviceLevelOptions = getData('serviceLevel');
    // const serviceProvidersCommonOptions = getOptions('productTestingServiceProvidersCommon');
    // const serviceProvidersOptionalOptions = getOptions('productTestingServiceProvidersOptionals');
    const icwServiceProviders = getOptions('icwServiceProviders');
    const connectedProviders = getOptions('connectedProviders');
    const {
      testingAttachments,
      testingProductInfos = [],
      remark,
      areas,
      serviceLevel,
      exportedMarket,
      buyerName,
      testingIntendedUsages = [],
      testingLabs,
      directLabs,
      isTicmart,
      isDirectLab,
      isICW,
      testingAndTestItemMaps,
    } = data;
    let productDetails = [];
    if (testingProductInfos.length) {
      const reduces = await testingProductInfos.reduce(async (acc, rawProduct) => {
        await acc;
        const { reportName, reportItemNo, itemName, itemNo, id } = rawProduct;

        const response = rawProduct.productProfile
          ? await apiGetProductDetail(rawProduct.productProfile.id)
          : {
              data: {
                productCategories: [],
                productSubCategories: { data: [] },
                files: [],
              },
            };

        const { productCategories, productSubCategories = { data: [] }, files } = response.data;

        productDetails.push({
          ...response.data,
          testingProductInfoId: id,
          itemName,
          itemNo,
          reportName,
          reportItemNo,
          productFiles: files?.default?.fileArr ?? [],
          productCategories: productSubCategories.data.map(
            ({ productSubCategory, productSubCategoryId }) => {
              const { productCategory } = productCategories.find(
                ({ productCategoryId }) =>
                  productSubCategory.productCategoryId === productCategoryId
              );
              return {
                subCategoryId: productSubCategoryId,
                categoryId: productSubCategory.productCategoryId,
                label: productSubCategory.name_en,
              };
            }
          ),
        });
        return Promise.resolve();
      }, Promise.resolve());
      setProductTestings([...productDetails]);
    }

    setRequirement({
      exportedMarket: exportedMarket,
      remarks: remark,
      countryOfOrigin: areas.map(({ id, country, ...rest }) => {
        return { value: id, label: country, rest, id, country };
      }),
      testItems: testingAndTestItemMaps.map(({ citationList, testItemList, id }) => ({
        id,
        citation: {
          value: citationList.id,
          label: citationList.name,
        },
        testItem: {
          value: testItemList.id,
          label: testItemList.name,
        },
      })),
      serviceLevel: serviceLevelOptions.find(({ value }) => value === serviceLevel),
      intendedUsage: testingIntendedUsages.map(({ id, name }) => ({ value: id, label: name })),
      buyerName,
      attachments: testingAttachments,
    });
    setTestingLab({
      testingLabs: (testingLabs || [])
        .filter(({ serviceProvider }) => !!serviceProvider)
        .map(({ serviceProvider, labName }) => {
          const option = icwServiceProviders.find(({ value }) => value === serviceProvider?.id);
          if (labName === 'No Preference')
            return {
              value: null,
              label: 'No Preference',
            };
          return {
            ...serviceProvider,
            ...option,
          };
        }),
      directLabs: (directLabs || [])
        .filter(({ laboratoryId }) => !!laboratoryId)
        .map(({ laboratoryId }) => {
          const option = connectedProviders.find(({ value }) => value === laboratoryId);
          return {
            ...option,
          };
        }),
      isTicmart,
      isDirectLab,
      isICW,
    });
  };

  const fetchProductTestingDetail = async () => {
    setFetchingProductDetails(true);
    const { data: response, status } = await apiProductTestingDetail(productTestingId);
    if (status === 200) {
      await extractData(response.data);
    }
    setFetchingProductDetails(false);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      await fetchProducts();

      if (productTestingId) {
        //Fetch detail and extracted to data.
        await fetchProductTestingDetail();
      }
    };
    fetchData();
    return fetchData;
  }, []);

  return (
    <CreateTestingJobContext.Provider
      value={{
        fetchProducts,
        onChange,
        pagination,
        search,
        order,
        filter,
        products,
        productTestings,
        addProductTesting,
        updateManyProductTesting,
        removeProductTesting,
        updateProductTesting,
        loading,
        onChangeRequirement,
        requirement,
        handleCreateOrder,
        fetchingProductDetails: fetchingProductDetails,
        testingLab,
        isUpdating: !!productTestingId,
        companyId,
      }}>
      {children}
    </CreateTestingJobContext.Provider>
  );
};
